export const BQ_CLICKED_RELATED_GUIDE = 'clicked_related_guide';
export const BQ_CLICKED_SEE_MORE_GUIDES = 'clicked_see_more_guides';
